import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(
    private firestore: AngularFirestore,
    private userService: UserService
  ) { }

  getModuleToken(username: string, module: string) {
    return this.firestore
      .collection("module_token", ref => ref.where('username', '==', username).where('module', '==', module))
      .snapshotChanges();
  }

  /**
   * Cek sekali (take(1)) apakah permission module di Firestore `module_token` berubah dibanding
   * token di localStorage; reload hanya kalau ISI permission-nya beda.
   *
   * Sejak token module v2 (`{permissions, userid, exp}`, 2026-09-03) tiap panggilan
   * get-permissions menerbitkan string token baru (exp berbeda) walau permission-nya sama.
   * Membandingkan string token + listener permanen dulu bikin reload terus-menerus (IF-84):
   * tiap load me-mint token baru -> Firestore berubah -> tab/app lain (ptnw-3.0) reload -> dst.
   */
  async syncModuleToken(moduleName: string) {
    if (location.hostname != "localhost" && location.hostname != "127.0.0.1") {
      let username = this.userService.getUsername();

      this.getModuleToken(username, moduleName).pipe(take(1)).subscribe(res => {

        let data: any = res.map(e => {
          return {
            documentId: e.payload.doc.id,
            ...(e.payload.doc.data() as {})
          } as {};
        }).shift();

        // doc module_token untuk user+module ini belum ada / tanpa token
        if (!data || data.token == null) {
          return;
        }

        const current = localStorage.getItem(moduleName);
        if (current === data.token) {
          return;
        }

        const currentPayload = this.decodeToken(current);
        const remotePayload = this.decodeToken(data.token);
        const remotePermissions = this.getPermissions(remotePayload);

        if (currentPayload && remotePermissions && this.samePermissions(this.getPermissions(currentPayload), remotePermissions)) {
          // permission sama, hanya beda terbitan -- pakai yg exp-nya paling lama, tanpa reload
          if ((remotePayload.exp || 0) > (currentPayload.exp || 0)) {
            localStorage.setItem(moduleName, data.token);
          }
          return;
        }

        // permission benar2 berubah (mis. diubah admin) -> reload sekali supaya menu/guard ikut
        localStorage.setItem(moduleName, data.token);
        document.location.reload();
      });
    }
  }

  private decodeToken(token: string): any {
    if (!token) {
      return null;
    }

    try {
      const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(atob(payload));
    } catch (ex) {
      return null;
    }
  }

  /** format lama = array datar route, format v2 = {permissions, userid, exp} */
  private getPermissions(payload: any): string[] {
    if (!payload) {
      return null;
    }
    if (Array.isArray(payload)) {
      return payload;
    }
    return Array.isArray(payload.permissions) ? payload.permissions : null;
  }

  private samePermissions(a: string[], b: string[]): boolean {
    if (!a || !b || a.length !== b.length) {
      return false;
    }
    const sortedB = [...b].sort();
    return [...a].sort().every((value, i) => value === sortedB[i]);
  }
}
